<template>
  <div v-if="validated && status === 'success'">
    <b-card class="text-center border border-danger">
      <h3 class="fs-2 fw-bold">
        This draft FVC Structured Product Research Report is confidential. <br>
        It is intended for representatives of the product provider company only. <br>
        It will cease to be valid once the report is live. <br><br>
        {{ message }}
      </h3>
    </b-card>

    <product-breakdown
      :report-flavour="'draft'"
      :fvcdetailsid = this.$route.params.fvcdetailsid
      :supplied-password = this.$route.params.providerpassword
    />
  </div>
  <div v-else>
    <b-card class="text-center border border-danger">
      <h3 class="fs-2 fw-bold">
        {{ message }}
      </h3>
    </b-card>
  </div>
</template>

<script>

import ProductBreakdown from '@/views/products/ProductBreakdown.vue'
import { BCard } from 'bootstrap-vue'

export default {
  name: 'ProviderDraft',
  components: {
    ProductBreakdown,
    BCard,
  },
  data() {
    return {
      validated: false,
      status: '',
      message: '',
    }
  },
  created() {
    this.checkUrlPassword()
  },
  methods: {
    checkUrlPassword() {
      const { fvcdetailsid, providerpassword } = this.$route.params

      this.$http.get('reportflavours.cfc', {
        params: {
          method: 'validateUrlPassword',
          flavour: 'draft',
          fvcdetailsid,
          urlpassword: providerpassword,
        },
      })
        .then(response => {
          const { data } = response
          if (data.STATUS === 'success') {
            this.validated = true
            this.status = data.STATUS
            this.message = data.MESSAGE
          } else if (data.STATUS === 'partial') {
            this.status = data.STATUS
            this.message = data.MESSAGE
          } else {
            this.$router.push({ name: 'home' })
          }
        })
        .catch(() => {
          this.$router.push({ name: 'home' })
        })
    },
  },
}
</script>
